import { render, staticRenderFns } from "./Logexception.vue?vue&type=template&id=c989a520&scoped=true"
import script from "./Logexception.vue?vue&type=script&lang=js"
export * from "./Logexception.vue?vue&type=script&lang=js"
import style0 from "./Logexception.vue?vue&type=style&index=0&id=c989a520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989a520",
  null
  
)

export default component.exports